import { render, staticRenderFns } from "./PrepareSelfie.vue?vue&type=template&id=0d6680e8&scoped=true"
import script from "./PrepareSelfie.vue?vue&type=script&lang=js"
export * from "./PrepareSelfie.vue?vue&type=script&lang=js"
import style0 from "./PrepareSelfie.vue?vue&type=style&index=0&id=0d6680e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6680e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VImg,VLayout,VRow})
